export default function chainPropTypes(propType1, propType2) {
    if ("production" === 'production') {
        return ()=>null;
    }
    return function validate() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return propType1(...args) || propType2(...args);
    };
}
